import type { AppUser } from "../../types/user";

export type AdminTab =
  | "Users"
  | "Teams"
  | "Questions"
  | "Analytics"
  | "Feedback"
  | "Audit"
  | "Integrations"
  | "Zendesk"
  | "Sentry"
  | "Status"
  | "Management"
  | "Permissions"
  | "Settings"
  | "Tenants";

export type AdminTabGroup = { label: string; tabs: readonly AdminTab[] };

export const ADMIN_TAB_GROUPS: readonly AdminTabGroup[] = [
  { label: "People & access", tabs: ["Users", "Teams", "Permissions"] },
  { label: "Monitoring", tabs: ["Analytics", "Status", "Audit", "Questions"] },
  { label: "Operations & system", tabs: ["Management", "Integrations", "Zendesk", "Sentry", "Feedback", "Settings"] },
  { label: "Platform", tabs: ["Tenants"] },
];

export type AdminUser = AppUser;

export type AdminCurrentUser = {
  role?: {
    name?: string | null;
  } | null;
};
